import {createAsyncThunk} from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';



const serviceName = "attendance-service";
const endPoint = "shift";

export const CreateAttendanceShift = createAsyncThunk("attendanceShift/CreateAttendanceShift",async (params, { dispatch, getState }) => {

    const response = await apiInstance.post(`${serviceName}/v1/${endPoint}/create`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const UpdateCreateAttendanceShift = createAsyncThunk("attendanceShift/UpdateCreateAttendanceShift",async (params, { dispatch, getState }) => {

    const response = await apiInstance.put(`${serviceName}/v1/${endPoint}/update`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});


export const GetAttendanceShiftById = createAsyncThunk('attendanceShift/GetAttendanceShiftById', async (params, { dispatch, getState }) => {
    const response = await apiInstance.get(`${serviceName}/v1/${endPoint}/by-id/${params}`).then((response) => {
        return response;
    }).catch((error) => {
        return error.response;
    });
    const { data, status } = response;
    return { data, status };
});
